<template>
  <div>
    <div class="f-table-block step">
      <div class="block">
        <div class="left">
          <i class="el-icon-circle-check blueIcon" />
        </div>
        <div class="right">
          <div class="top blueIcon">
            第1步
          </div>
          <div class="bottom gray">
            完善基础信息
          </div>
        </div>
        <div class="square-box">
          <div class="square" />
        </div>
      </div>
      <div class="block">
        <div class="left">
          <span
            class="circle"
            :class="stepIndex === '2' ? 'blue blueIcon' : ''"
          >2</span>
        </div>
        <div class="right">
          <div
            class="top"
            :class="stepIndex === '2' ? 'blueIcon' : ''"
          >
            第2步
          </div>
          <div class="bottom gray">
            配置活动模版
          </div>
        </div>
        <div class="square-box">
          <div class="square" />
        </div>
      </div>
      <!-- <div class="block">
        <div class="left">
          <span class="circle">3</span>
        </div>
        <div class="right">
          <div class="top">第3步</div>
          <div class="bottom gray">设置分享裂变</div>
        </div>
        <div class="square-box">
          <div class="square"></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepIndex: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.step {
  border-bottom: 1px solid rgb(236, 236, 236);
  display: flex;
  flex: 1;
  .block {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    .left {
      margin-right: 10px;
      font-size: 20px;
      .circle {
        font-size: 14px;
        display: inline-table;
        border-radius: 15px;
        border: 1px solid rgb(102, 102, 102);
        width: 26px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        vertical-align: middle;
      }
      .blue {
        border: 1px solid rgb(61, 152, 249);
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .bottom {
        font-size: 14px;
      }
    }
    .blueIcon {
      color: rgb(61, 152, 249);
    }
    .gray {
      color: rgb(164, 164, 164);
    }
    .square-box {
      margin-right: 30px;

      transform: rotate(315deg);
      width: 56px;
      height: 56px;
      border-bottom: 1px solid rgb(236, 236, 236);
      border-right: 1px solid rgb(236, 236, 236);
    }
  }
}
</style>
